import { useQuery } from '@tanstack/react-query';
import { getEnabledLocationsApi } from '../api/location';

export const useEnabledLocations = () =>
  useQuery({
    queryKey: ['locations', 'enabled'],
    queryFn: getEnabledLocationsApi,
    staleTime: 10 * 60 * 1000,
    select: (data) => data?.countries ?? [],
  });
